"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTranslations = exports.shouldFetchTranslations = exports.updateCookie = void 0;
const Endpoints_1 = require("../Constants/Endpoints");
const react_1 = require("react");
const Utils_1 = require("../Utils");
const dayjs_1 = __importDefault(require("dayjs"));
const react_redux_1 = require("react-redux");
const translations_1 = require("@/Redux/Actions/translations");
const spa_core_1 = require("@episerver/spa-core");
const retries = 5;
let fetchIndex = 0;
let initialFetch = true;
const updateCookie = (minutes = Endpoints_1.Cookies.TRANSLATIONS_REFETCH_TIME_IN_MINUTES, now, cookieName) => {
    const expireDate = now.add(minutes, 'm');
    const cookieValue = expireDate.unix().toString();
    (0, Utils_1.setCookie)(cookieName, cookieValue);
};
exports.updateCookie = updateCookie;
const shouldFetchTranslations = (cookieName) => {
    const translationsCookie = (0, Utils_1.getCookie)(cookieName);
    const now = (0, dayjs_1.default)();
    if (!translationsCookie) {
        (0, exports.updateCookie)(Endpoints_1.Cookies.TRANSLATIONS_REFETCH_TIME_IN_MINUTES, now, cookieName);
        return true;
    }
    if (parseInt(translationsCookie) < now.unix()) {
        (0, exports.updateCookie)(Endpoints_1.Cookies.TRANSLATIONS_REFETCH_TIME_IN_MINUTES, now, cookieName);
        return true;
    }
    return false;
};
exports.shouldFetchTranslations = shouldFetchTranslations;
const useTranslations = () => {
    var _a, _b;
    const cmsState = (0, spa_core_1.useCmsState)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { translations, isLoading, isReady } = (0, react_redux_1.useSelector)((state) => state.translations);
    const id = (_b = (_a = cmsState === null || cmsState === void 0 ? void 0 : cmsState.iContent) === null || _a === void 0 ? void 0 : _a.contentLink) === null || _b === void 0 ? void 0 : _b.id;
    (0, react_1.useEffect)(() => {
        if (!id)
            return;
        if (isLoading || isReady) {
            return;
        }
        if ((translations === null || translations === void 0 ? void 0 : translations.length) <= 0 || (0, exports.shouldFetchTranslations)(Endpoints_1.Cookies.TRANSLATIONS_REFETCH_TIME)) {
            if (fetchIndex === retries) {
                console.warn('Maximum amount of retries reached for translations.');
                return;
            }
            if (initialFetch) {
                initialFetch = false;
                dispatch((0, translations_1.fetchTranslations)());
                fetchIndex++;
            }
            else {
                setTimeout(() => {
                    dispatch((0, translations_1.fetchTranslations)());
                    fetchIndex++;
                }, 4000);
            }
        }
    }, [id, translations, isLoading, isReady]);
};
exports.useTranslations = useTranslations;
